// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__kkVLu","content":"styles_content__3da3z","checkbox":"styles_checkbox__2bIw0","checkboxLabel":"styles_checkboxLabel__345Do"};